<div class="classification-container">
	<span class="tip">_Selecione um tipo de classificação</span>
	<div class="classification-list">
		<div class="classification-item" *ngFor="let serviceTypes of availableServiceTypes">{{ serviceTypes }}</div>
	</div>
</div>
